import { Action } from 'redux';

import { PublishedConnectionTableExtractsRefreshNow } from '../../bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export interface PublishedConnectionTableExtractsRefreshNowAction extends Action {
  readonly selectedContent: IContentInfo[];
}

export function publishedConnectionTableExtractsRefreshNow(selectedContent: IContentInfo[]): PublishedConnectionTableExtractsRefreshNowAction {
  return {
    type: PublishedConnectionTableExtractsRefreshNow,
    selectedContent
  };
}
